import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 8h4","key":"svg-0"}],["path",{"d":"M12 8v8","key":"svg-1"}]]

const IconLetterTSmall = createReactComponent('outline', 'letter-t-small', 'LetterTSmall', __iconNode);

export default IconLetterTSmall;